import React from 'react';
import styles from './About.module.css';

const About = () => {
  return (
    <section className={styles['about-section']}>
      <div className={styles['container']}>
        <div className={styles['text-wrapper']}>
          <h2 className={styles['heading']}>About MetalZulu</h2>
          <p className={styles['paragraph']}>
            MetalZulu is a cutting-edge platform designed to revolutionize industrial procurement and digital transformation. 
            Our mission is to provide scalable, secure, and smart solutions that empower manufacturers, suppliers, and businesses to grow in a connected ecosystem.
          </p>
          <p className={styles['paragraph']}>
            With a focus on technology, trust, and transparency, MetalZulu brings together the best in AI, cloud computing, and enterprise tools to drive innovation across industries.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;